import { Skeleton } from '../../ui/Feedback';

export function WorkspaceSkeleton() {
  return (
    <div className="workspace">
      <div className="workspace-header" />
      <div />
      <div className="workspace__body" style={{ gridTemplateColumns: '42% 8px minmax(0, 1fr)' }}>
        <div className="pane" style={{ padding: 24, gap: 12, display: 'grid', alignContent: 'start' }}>
          <Skeleton width="45%" height={22} />
          <Skeleton width="30%" />
          <Skeleton width="100%" />
          <Skeleton width="92%" />
          <Skeleton width="80%" />
          <Skeleton width="100%" height={96} />
        </div>
        <div />
        <div className="pane" />
      </div>
    </div>
  );
}
